// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".end-back[data-v-24e608ac]{background:#fff;min-height:100%;width:72%;position:relative;overflow:hidden;padding:21rem 0 2rem;display:flex;justify-content:center;align-items:center}.top-back[data-v-24e608ac]{width:125%;height:33vw;background:#2cb774;border-radius:50%;position:absolute;top:-23vw}.top-img[data-v-24e608ac]{position:absolute;top:3rem}.top-img img[data-v-24e608ac]{width:16vw}.back-home-button[data-v-24e608ac]{position:absolute;top:2%;right:1%}", ""]);
// Exports
module.exports = exports;
